<template lang="pug">
  .hair-color-bar-membership.container
    .row.container-wrapper
      h4.section-title.xs-f-xmedium.text-center.max-at-tweak {{membershipName}} Membership
      .perks-wrap.xs-pl-100m.xs-pr-100m.md-pl-200m.md-pr-200m
        .service-wrap.xs-12.xs-mt-200m.sm-mt-400m
          .service-icon.xs-hide.sm-pl-50m.md-pl-300m.lg-pl-500m
            mr-icon(name="shiny-hair")

          .service-info.sm-pl-100m.md-pl-200m
            h5.xs-f-large.bold.max-at-tweak {{membershipName}}
              span(v-if="selectedLimitlessProPlusPrice") &nbsp;${{ selectedLimitlessProPlusPrice }}/Every 4 weeks

            p.xs-f-small.max-at-tweak Get your roots done as often as you need at any of our Hair Color Bar locations nation-wide.

        .xs-12.xs-mt-100m
          .divider
            span.xs-f-xmedium.max-at-tweak.brand-color-2 PLUS

        CMSPartial(mixin-key="partial-urm-perks")

      template(v-if="location._id")
        .xs-12.xs-mb-100m
          .divider
            span.xs-f-xmedium.max-at-tweak.brand-color-2 AT

        .xs-12.xs-pr-150m.xs-pl-150m.md-pl-500m.md-pr-500m.md-pb-300m
          HcbLocation(cta-event-prefix="Limitless Pro+ Landing page")

    .row.container-wrapper.search
      HcbLocationSearch

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CMSPartial from "@components/CMSPartial";
import HcbLocationSearch from "./HcbLocationSearch";
import HcbLocation from "./HcbLocation/HcbLocation";

export default {
  name: "HairColorBarMembership",
  components: {
    HcbLocation,
    HcbLocationSearch,
    CMSPartial
  },

  inject: ['getObjProperty'],

  props: {
    cmsSettings: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState('colorbar', [
      'location'
    ]),

    ...mapState('constants', [
      'limitless'
    ]),

    ...mapGetters('colorbar', [
      'selectedLimitlessProPlusPrice'
    ]),

    membershipName() {
      let name = this.getObjProperty(this, 'cmsSettings.membershipName');
      return name ? name : this.limitless.PRO_PLUS;
    }
  }
};

</script>

<style scoped lang="stylus">
.hair-color-bar-membership

  .container-wrapper
    background-color ui-color-1
    max-width 54em
    margin 0 auto
    box-shadow 0px 0px 40px rgba(0, 0, 0, 0.07)
    border-radius 4px

  .section-title
    position absolute
    color ui-color-1
    top -2em
    left 50%
    transform translate(-50%, 0)
    z-index 10
    padding 1em
    background-color brand-color-1
    width 21em

  .service-wrap
    background-color ui-color-3
    padding 2em

  .service-icon
    display inline-block
    vertical-align top

    svg
      width 5.5em

  .service-info
    display inline-block
    vertical-align top
    max-width 35em
    p
      max-width 26em

  .divider
    border-top 1px solid brand-color-1
    width 20em
    margin 2em auto

    span
      top 50%
      position absolute
      left 50%
      transform translate(-50%, -50%)
      background-color white
      padding 0 1em

  .bottom-link
    margin-top 26px

  .search
    margin-top 2em
    margin-bottom 3em

  @media mq-mobile
    .service-wrap
      padding 2em 1em

    .section-title
      width 100%
      position relative
      top 0

    .service-info
      text-align center

</style>